module.exports = __webpack_public_path__ + "static/media/WoundsThreshold.fb9ddabb.svg";